
import React from 'react'
import { useEffect, useState, useCallback } from 'react'
import PropTypes from 'prop-types'
import tinycolor from 'tinycolor2'
import './index.less'

export default function ColorPalette(props) {
  const [colorButtonIfon, setColorButtonIfon] = useState({
    isPress: false,
    pressCurrentX: null,
    pressCurrentY: null,
    currentX: 0,
    currentY: 0,
    pressX: null,
    pressY: null,
    maxX: null,
    maxY: null,
    backColor: null
  })
  const [hIfon, setHifon] = useState({
    isPress: false,
    pressX: null,
    pressY: null,
    pressCurrentX: null,
    pressCurrentY: null,
    currentX: 0,
    currentY: 0,
    maxX: null,
    maxY: null
  })
  const [sIfon, setSifon] = useState({
    isPress: false,
    pressX: null,
    pressY: null,
    pressCurrentX: null,
    pressCurrentY: null,
    currentX: 0,
    currentY: 0,
    maxX: null,
    maxY: null
  })
  const [vIfon, setVifon] = useState({
    isPress: false,
    pressX: null,
    pressY: null,
    pressCurrentX: null,
    pressCurrentY: null,
    currentX: 0,
    currentY: 0,
    maxX: null,
    maxY: null
  })
  const [colors, setColors] = useState({
    hex: props.color ? props.color : null,
    rgb: props.color ? props.color : null
  })
  const [openIfon, setopenIfon] = useState({
    openValue: 'colorPalette',
    isItCorrect: false,
    inputValue: null
  })

  ColorPalette.prototype.colorButtonIfonObj = {
    colorButtonIfon,
    setColorButtonIfon
  }
  ColorPalette.prototype.hIfonObj = {
    hIfon,
    setHifon
  }
  ColorPalette.prototype.sIfonObj = {
    sIfon,
    setSifon
  }
  ColorPalette.prototype.vIfonObj = {
    vIfon,
    setVifon
  }

  const [doms] = useState({
    tintingDom: React.createRef(),
    hDom: React.createRef(),
    sDom: React.createRef(),
    vDom: React.createRef()
  })

  const func = useCallback(() => {
    ColorPalette.prototype.colorButtonIfonObj.setColorButtonIfon({
      ...ColorPalette.prototype.colorButtonIfonObj.colorButtonIfon,
      isPress: false
    })
    ColorPalette.prototype.hIfonObj.setHifon({
      ...ColorPalette.prototype.hIfonObj.hIfon,
      isPress: false
    })
    ColorPalette.prototype.sIfonObj.setSifon({
      ...ColorPalette.prototype.sIfonObj.sIfon,
      isPress: false
    })
    ColorPalette.prototype.vIfonObj.setVifon({
      ...ColorPalette.prototype.vIfonObj.vIfon,
      isPress: false
    })
  }, [doms.tintingDom])

  useEffect(() => {
    const tintingDomIfon = doms.tintingDom.current.getBoundingClientRect()
    const hDomIfon = doms.hDom.current.getBoundingClientRect()

    const ButtonIfon = {
      ...colorButtonIfon,
      maxX: tintingDomIfon.width,
      maxY: tintingDomIfon.height
    }

    const Hifon = {
      ...hIfon,
      maxX: hDomIfon.width,
      maxY: 0
    }

    const Sifon = {
      ...sIfon,
      maxX: hDomIfon.width,
      maxY: 0
    }

    const Vifon = {
      ...vIfon,
      maxX: hDomIfon.width,
      currentX: hDomIfon.width,
      maxY: 0
    }

    const colorIfon = analysisColor(colors.rgb, ButtonIfon, Hifon, Sifon, Vifon)
    ButtonIfon.backColor = colorIfon.backColor
    ButtonIfon.currentX = colorIfon.colorBoardX
    ButtonIfon.currentY = colorIfon.colorBoardY
    Hifon.currentX = colorIfon.hx
    Sifon.currentX = colorIfon.sx
    Vifon.currentX = colorIfon.vx

    setColorButtonIfon(ButtonIfon)

    setHifon(Hifon)

    setSifon(Sifon)

    setVifon(Vifon)

    window.addEventListener('mouseup', func)
    return () => {
      window.removeEventListener('mouseup', func)
    }
  }, [doms.tintingDom])

  useEffect(() => {
    const h = hIfon.currentX / hIfon.maxX * 360
    const s = colorButtonIfon.currentX / colorButtonIfon.maxX * 100
    const v = 100 - (colorButtonIfon.currentY / colorButtonIfon.maxY * 100)
    const color = tinycolor(`hsv(${h},${s},${v})`)
    setColors({
      hex: color.toHexString(),
      rgb: color.toRgbString()
    })
    props.setColor && props.setColor({
      hex: color.toHexString(),
      rgb: color.toRgbString()
    })
  }, [hIfon.currentX, colorButtonIfon.currentX, colorButtonIfon.currentY, colorButtonIfon.maxY])

  return (<div className='ColorPalette'>
    <div className='ColorPalette_titleArea'>
      <span className='titleArea_color' style={{
        backgroundColor: colors.rgb
      }}></span>
      <div className='titleArea_colorIfon'>
        <i className='colorIfon_icon'>#</i>
        <input className='colorIfon_input' onBlur={() => {
          setopenIfon({
            ...openIfon,
            inputValue: null
          })
        }} onChange={(event) => {
          const value = event.target.value
          let value1 = value
          if (value1.indexOf('rgb(') !== 0 || value1[0] !== '#') {
            value1 = '#' + value1
          }
          const color = tinycolor(value1)
          let isItCorrect = false
          if (color.isValid()) {
            isItCorrect = true
          }
          setopenIfon({
            ...openIfon,
            inputValue: value,
            isItCorrect
          })
          if (isItCorrect) {
            const ifon = analysisColor(value, colorButtonIfon, hIfon, sIfon, vIfon)
            assignment({ colorButtonIfon, setColorButtonIfon }, { hIfon, setHifon }, { sIfon, setSifon }, { vIfon, setVifon }, ifon)
          }
        }} value={judge(colors, openIfon)} />
      </div>
    </div>
    <div className='ColorPalette_selection'>
      <div className='selection_title publicTitleArea' onClick={() => {
        setopenIfon({ ...openIfon, openValue: 'colorBoard' })
      }}>
        <span className='title_title'>标准色板</span>
        <i className={`title_icon ${openIfon.openValue === 'colorBoard' ? 'active' : ''}`}>{'>'}</i>
      </div>
      {openIfon.openValue === 'colorBoard' && <div className='selection_main' onClick={(event) => {
        const color = event.target.dataset.color
        if (!color) {
          return
        }

        const colorIfon = analysisColor(color, colorButtonIfon, hIfon, sIfon, vIfon)
        assignment({ colorButtonIfon, setColorButtonIfon }, { hIfon, setHifon }, { sIfon, setSifon }, { vIfon, setVifon }, colorIfon)
        setColors({
          ...colors,
          rgb: color
        })
      }}>
        {generateColorBlock(props.selectionColors, colors.rgb)}
      </div>}

    </div>
    <div className='ColorPalette_colorPalette'>
      <div className='colorPalette_title publicTitleArea' onClick={() => {
        setopenIfon({ ...openIfon, openValue: 'colorPalette' })
      }}>
        <span className='title_title'>自定义</span>
        <i className={`title_icon ${openIfon.openValue === 'colorPalette' ? 'active' : ''}`}>{'>'}</i>
      </div>
      {openIfon.openValue === 'colorPalette' && <div className='colorPalette_main'>
        <div className='main_tinting' style={{
          backgroundColor: colorButtonIfon.backColor
        }} ref={doms.tintingDom} onMouseMove={(event) => {
          if (!colorButtonIfon.isPress) {
            return
          }
          const ifon = handleMove(event, colorButtonIfon, setColorButtonIfon, openIfon, setopenIfon)
          const targetValue = operation(ifon.X, colorButtonIfon.maxX, sIfon.maxX)
          const targetValue1 = operation(ifon.Y, colorButtonIfon.maxY, sIfon.maxX)
          setSifon({
            ...sIfon,
            currentX: targetValue
          })
          setVifon({
            ...vIfon,
            currentX: sIfon.maxX - targetValue1
          })
        }} onMouseUp={(event) => {
          handleUp(event, colorButtonIfon, setColorButtonIfon)
        }}>
          <div className='tinting_colorBoard' ></div>
          <div className='tinting_colorBoard1' ></div>
          <i className='tinting_colorButton' style={{
            transform: `translate(${colorButtonIfon.currentX - 7}px, ${colorButtonIfon.currentY - 7}px)`,
            backgroundColor: colors.rgb
          }} onMouseDown={(event) => {
            handleDown(event, colorButtonIfon, setColorButtonIfon)
          }}></i>
        </div>

        <div className='main_H public_hsv'>
          <span className='hsv_title'>H</span>
          <div className='hsv_box' ref={doms.hDom} onMouseMove={(event) => {
            if (!hIfon.isPress) {
              return
            }
            const ifon = handleMove(event, hIfon, setHifon, openIfon, setopenIfon)
            setColorButtonIfon({
              ...colorButtonIfon,
              backColor: tinycolor(`hsv(${ifon.X / hIfon.maxX * 360
              }, 100, 100)`).toHexString()
            })
          }} onMouseUp={(event) => {
            handleUp(event, hIfon, setHifon)
          }}>
            <i className='box_icon' style={{
              transform: `translate(${hIfon.currentX - 4}px, ${hIfon.currentY - 7}px)`
            }} onMouseDown={(event) => {
              handleDown(event, hIfon, setHifon)
            }}></i>
          </div>
        </div>

        <div className='main_S public_hsv'>
          <span className='hsv_title'>S</span>
          <div className='hsv_box' style={{
            backgroundColor: colorButtonIfon.backColor
          }} ref={doms.sDom} onMouseMove={(event) => {
            if (!sIfon.isPress) {
              return
            }
            const ifon = handleMove(event, sIfon, setSifon, openIfon, setopenIfon)
            const targetValue = operation(ifon.X, sIfon.maxX, colorButtonIfon.maxX)
            setColorButtonIfon({
              ...colorButtonIfon,
              currentX: targetValue
            })
          }} onMouseUp={(event) => {
            handleUp(event, sIfon, setSifon)
          }}>
            <i className='box_icon' style={{
              transform: `translate(${sIfon.currentX - 4}px, ${sIfon.currentY - 7}px)`
            }} onMouseDown={(event) => {
              handleDown(event, sIfon, setSifon)
            }}></i>
          </div>
        </div>

        <div className='main_V public_hsv'>
          <span className='hsv_title'>V</span>
          <div className='hsv_box' style={{
            backgroundColor: colorButtonIfon.backColor
          }} ref={doms.vDom} onMouseMove={(event) => {
            if (!vIfon.isPress) {
              return
            }
            const ifon = handleMove(event, vIfon, setVifon, openIfon, setopenIfon)
            const targetValue = operation(ifon.X, vIfon.maxX, colorButtonIfon.maxY)
            setColorButtonIfon({
              ...colorButtonIfon,
              currentY: colorButtonIfon.maxY - targetValue
            })
          }} onMouseUp={(event) => {
            handleUp(event, vIfon, setVifon)
          }}>
            <i className='box_icon' style={{
              transform: `translate(${vIfon.currentX - 4}px, ${vIfon.currentY - 7}px)`
            }} onMouseDown={(event) => {
              handleDown(event, vIfon, setVifon)
            }}></i>
          </div>
        </div>
      </div>}

    </div>
  </div>)
}

ColorPalette.defaultProps = {
  selectionColors: [{
    color: 'rgb(255, 255, 255)',
    id: 1
  }, {
    color: 'rgb(235, 235, 235)',
    id: 2
  }, {
    color: 'rgb(184, 184, 184)',
    id: 3
  }, {
    color: 'rgb(133, 133, 133)',
    id: 4
  }, {
    color: 'rgb(82, 82, 82)',
    id: 5
  }, {
    color: 'rgb(31, 31, 31)',
    id: 6
  }, {
    color: 'rgb(0, 0, 0)'
  }, {
    color: 'rgb(247, 97, 92)',
    id: 8
  }, {
    color: 'rgb(255, 177, 61)',
    id: 9
  }, {
    color: 'rgb(255, 234, 77)',
    id: 10
  }, {
    color: 'rgb(141, 224, 128)',
    id: 11
  }, {
    color: 'rgb(91, 222, 200)',
    id: 12
  }, {
    color: 'rgb(99, 188, 255)',
    id: 13
  }, {
    color: 'rgb(250, 140, 244)',
    id: 14
  }, {
    color: 'rgb(222, 40, 33)',
    id: 15
  }, {
    color: 'rgb(237, 141, 24)',
    id: 16
  }, {
    color: 'rgb(250, 217, 2)',
    id: 17
  }, {
    color: 'rgb(69, 186, 79)',
    id: 18
  }, {
    color: 'rgb(10, 194, 169)',
    id: 19
  }, {
    color: 'rgb(47, 142, 237)',
    id: 20
  }, {
    color: 'rgb(210, 89, 212)',
    id: 21
  }, {
    color: 'rgb(153, 37, 31)',
    id: 22
  }, {
    color: 'rgb(184, 87, 28)',
    id: 23
  }, {
    color: 'rgb(217, 166, 26)',
    id: 24
  }, {
    color: 'rgb(52, 140, 70)',
    id: 25
  }, {
    color: 'rgb(29, 138, 127)',
    id: 26
  }, {
    color: 'rgb(30, 100, 166)',
    id: 27
  }, {
    color: 'rgb(140, 66, 143)',
    id: 28
  }],
  color: 'rgb(255, 255, 255)'
}

ColorPalette.propTypes = {
  selectionColors: PropTypes.arrayOf(PropTypes.object),
  color: PropTypes.string
}

function generateColorBlock(colors, color) {
  return colors.map((el, index) => {
    return (<span className={`colorBlock ${color === el.color ? 'active' : ''}`} data-color={el.color} key={el.color} style={{
      backgroundColor: el.color
    }}></span>)
  })
}

function handleDown({ clientX, clientY }, ifon, setIfon) {
  setIfon({
    ...ifon,
    isPress: true,
    pressX: clientX,
    pressY: clientY,
    pressCurrentX: ifon.currentX < 0 ? 0 : ifon.currentX,
    pressCurrentY: ifon.currentY < 0 ? 0 : ifon.currentY
  })
}

function handleMove({ clientX, clientY }, ifon, setIfon, openIfon, setopenIfon) {
  let X = (clientX - ifon.pressX)
  let Y = (clientY - ifon.pressY)
  X = ifon.pressCurrentX + X
  Y = ifon.pressCurrentY + Y

  if (X < 0) {
    X = 0
  }
  if (Y < 0) {
    Y = 0
  }
  if (X > ifon.maxX) {
    X = ifon.maxX
  }
  if (Y > ifon.maxY) {
    Y = ifon.maxY
  }
  setIfon({
    ...ifon,
    currentX: X,
    currentY: Y
  })

  setopenIfon({
    ...openIfon,
    inputValue: null
  })
  return {
    X,
    Y
  }
}

function handleUp({ clientX, clientY }, ifon, setIfon) {
  setIfon({
    ...ifon,
    isPress: false
  })
}

function operation(currentValue, ownMaxValue, maxValue) {
  const value = currentValue / ownMaxValue
  const targetValue = value * maxValue
  return targetValue
}

function analysisColor(color, colorButtonIfon, hifon, sifon, vifon) {
  const hsv = tinycolor(color).toHsv()
  const hx = operation(hsv.h, 360, hifon.maxX)
  const sx = operation(hsv.s * 100, 100, sifon.maxX)
  const vx = operation(hsv.v * 100, 100, vifon.maxX)
  const colorBoardX = operation(sx, sifon.maxX, colorButtonIfon.maxX)
  const colorBoardY = colorButtonIfon.maxY - operation(vx, vifon.maxX, colorButtonIfon.maxY)
  const backColor = tinycolor(`hsv(${hsv.h},100,100)`).toHexString()
  return {
    hsv,
    hx,
    sx,
    vx,
    colorBoardX,
    colorBoardY,
    backColor
  }
}

function judge(colors, openIfon) {
  let value = openIfon.inputValue === null ? colors.hex : openIfon.inputValue
  if (!value) {
    return ''
  }
  value = value.trim()
  value = value[0] === '#' ? value.slice(1) : value
  return value
}

function assignment(obj1, objh, objs, objv, ifon) {
  obj1.setColorButtonIfon({
    ...obj1.colorButtonIfon,
    backColor: ifon.backColor,
    currentX: ifon.colorBoardX,
    currentY: ifon.colorBoardY
  })
  objh.setHifon({
    ...objh.hIfon,
    currentX: ifon.hx
  })
  objs.setSifon({
    ...objs.sIfon,
    currentX: ifon.sx
  })
  objv.setVifon({
    ...objv.vIfon,
    currentX: ifon.vx
  })
}

